import { ENDPOINTS } from "@horseed/shared/endpoints";
import { API_BASE_URL, apiRequest } from "./http";

const { SETTINGS } = ENDPOINTS;

export const SITE_SETTINGS_DEFAULTS = {
  phone1: "+252 65 390 0373",
  phone2: "+252 63 390 0373",
  email1: "Info@Hornpetroleum.Com",
  email2: "Horn@Hornpetroleum.Com",
  address1: "Hargeisa,Damal Bussiness Center 2nd Floor.",
  address2: "Garowe, Road No 1, Near the UN Office.",
  facebookUrl: "https://www.facebook.com/HornPetroleumGroup",
  instagramUrl: "https://www.instagram.com/horn_petroleum/?igshid=M2RkZGJiMzhjOQ%3D%3D",
  tiktokUrl: "https://www.tiktok.com/",
  whatsappUrl: "https://wa.me/252653900373",
  xUrl: "https://x.com/horn_petroleum",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3934.386168164287!2d44.06175307383609!3d9.561940680421554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOcKwMzMnNDMuMCJOIDQ0wrAwMyc1MS42IkU!5e0!3m2!1sen!2s!4v1734549119992!5m2!1sen!2s",
};

function normalizeSiteSettings(data) {
  const raw = data || {};
  const normalized = Object.keys(SITE_SETTINGS_DEFAULTS).reduce((acc, key) => {
    const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
    const value = raw[key] ?? raw[pascalKey];
    acc[key] = value && String(value).trim() ? value : SITE_SETTINGS_DEFAULTS[key];
    return acc;
  }, {});

  const legacyXUrl = raw.twitterUrl ?? raw.TwitterUrl;
  if (legacyXUrl && String(legacyXUrl).trim()) {
    normalized.xUrl = legacyXUrl;
  }

  return normalized;
}

export async function getSiteSettings() {
  try {
    const json = await apiRequest(`${API_BASE_URL}${SETTINGS.SITE}`);
    return normalizeSiteSettings(json?.data);
  } catch (_) {
    return SITE_SETTINGS_DEFAULTS;
  }
}

export function getSocialLinks(settings) {
  const source = settings || SITE_SETTINGS_DEFAULTS;
  return [
    { key: "facebook", label: "Facebook", url: source.facebookUrl, icon: "fab fa-facebook-f" },
    { key: "instagram", label: "Instagram", url: source.instagramUrl, icon: "fab fa-instagram" },
    { key: "tiktok", label: "TikTok", url: source.tiktokUrl, iconText: "T" },
    { key: "whatsapp", label: "WhatsApp", url: source.whatsappUrl, icon: "fab fa-whatsapp" },
    { key: "x", label: "X", url: source.xUrl || source.twitterUrl, iconText: "X" },
  ].filter(item => item.url && String(item.url).trim());
}
